import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  color: white;
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  .mark-down {
    font-size: 16px;
    font-family: 'Poppins', sans-serif;
    line-height: 30px;
    font-weight: 300;

    li {
      margin-bottom: 4px;
    }
  }
`;

export const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 30px;

  &:first-child {
    width: 600px;
  }

  &:last-child {
    padding-top: 30px;
    max-width: 300px;
    border-left: 1px solid #334;
    padding-left: 30px;
  }
`;
